import styled from '@emotion/styled'

import maxios from '~/@common/utils/maxios'

import { ExternalLoginButton } from './ExternalLoginButton'
import { useNaverWorksLogin } from './useNaverWorksLogin'

/**
 * 외부 SSO 로그인 진입점 레일.
 * - 네이버 웍스(웨일 스페이스) 로그인 + AIEP 로그인 링크를 나란히 배치.
 * - `isSchoolflat` 분기 하에서만 렌더되는 b2g 전용 UI.
 *
 * AIEP 로그인은 SAML 2.0 플로우이므로 백엔드 SAML 엔드포인트로 직접 이동시킨다
 * (SP-initiated SSO). 콜백은 /aiep/bridge로 돌아와 AiepBridgePage가 처리.
 */
export const ExternalLoginButtonRails = () => {
  const { authURI } = useNaverWorksLogin()
  const aiepAuthUrl = `${maxios.defaults.baseURL}/saml2/authenticate/schoolflat`

  return (
    <Wrapper>
      <ExternalLoginButton authUrl={authURI}>네이버 웍스(웨일 스페이스) 로그인</ExternalLoginButton>
      ㅣ<ExternalLoginButton authUrl={aiepAuthUrl}>AIEP 로그인</ExternalLoginButton>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  color: var(--Colors-Blue-700);
  margin-bottom: 16px;
`
